module.exports = __webpack_public_path__ + "img/edit.9ea4cc44.svg";